import type { Step } from '@/components/wizard/Step';

import type { CreateJobTemplateWizardState } from './createJobTemplateWizardState';
import { CreateJobTemplateStep } from './steps/CreateJobTemplateStep';

export const CreateJobTemplateFlow: Step<CreateJobTemplateWizardState> = {
  id: 'create_job_template',
  Component: CreateJobTemplateStep,
};
